import "rxjs/add/observable/of";
import "rxjs/add/operator/first";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";

import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {Http, Response} from "@angular/http";
import {ErrorService} from "./error.service";
import {PreloaderService} from "./preloader.service";
import {ReplaySubject} from "rxjs/ReplaySubject";

@Injectable()
export class LoaderService {
  private cache = new ObservableCache(3000);


  constructor(protected http: Http,
              protected errorService: ErrorService,
              protected preloaderService: PreloaderService) {
  }


  public load(url: string) {
    //console.log(`load ${url}`);
    return this.sendGet(url);
  }


  protected sendPost(url: string, body?: any): Observable<Response> {
    return this.sendPostImpl(url, body);
  }


  protected sendPostAndCache(url: string, body: any) {
    const stringified = JSON.stringify(body);

    if (this.cache.hasValidObservable(stringified)) {
      return this.cache.getObservable(stringified);
    }

    const observable = this.createReplayObservable(url, body);
    this.cache.updateObservable(stringified, observable);
    return observable;
  }


  private createReplayObservable(url: string, body: any):Observable<Response> {
    const subject = new ReplaySubject();
    const subscription = this.sendPost(url, body)
      .subscribe(r => {
        subject.next(r);
        subscription.unsubscribe();
      });
    return subject.asObservable();
  }


  private sendPostImpl(url: string, body: any): Observable<Response> {
    this.preloaderService.show();
    console.log(`send post ${url}`);
    console.log(`send post ${url} ${JSON.stringify(body)}`);
    return this.http.post(url, body)
      .map((r: Response): Response => {
        console.log(`post response ${r.url}`);
        this.preloaderService.hide();
        return r;
      })
      .catch((e: any): any =>{
        console.log(e);
        this.errorService.handleError(e);
      });
  }


  private sendGet(url:string): Observable<Response> {
    return this.http.get(url)
      .map((r: Response): Response => {
        this.preloaderService.hide();
        return r;
      })
      .catch((e: any): any => this.errorService.handleError(e));
  }
}


/* INTERNAL */


interface IObservableCacheRecord {
  timestamp: number;
  observable: Observable<Response>;
}


class ObservableCache {
  private map: Map<string, IObservableCacheRecord> = new Map();

  constructor(private cacheTimeMillis: number = 1500) {
  }


  /**
   * @param key
   * @returns {IObservableCacheRecord}
   */
  private getRecord(key: string) {
    return this.map.get(key)
  }


  hasValidObservable(key: string): boolean {
    if (!this.map.has(key)) {
      return false;
    }

    let elapsed: number = Date.now() - this.getRecord(key).timestamp;
    return elapsed <= this.cacheTimeMillis;
  }

  getObservable(key: string) {
    return this.getRecord(key).observable;
  }


  updateObservable(key: string, observable: Observable<Response>) {
    let record: IObservableCacheRecord = <IObservableCacheRecord> {
      timestamp: Date.now(),
      observable: observable
    };
    this.map.set(key, record);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/loader.service.ts